import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../hooks/CustomHook';
import { getSortedNews, newsCategoryStyle, formatNewsDate } from '../data/news';

const FILTERS = ['全部', '产品动态', '公司动态', '团队活动', '媒体报道'];

const Cover = ({ item }) => {
    if (item.cover) {
        return (
            <img
                src={item.cover}
                alt={item.title}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
            />
        );
    }
    return (
        <div className="w-full h-full bg-gradient-to-br from-slate-400 to-blue-600 flex items-center justify-center">
            <span className="text-white/90 text-3xl" aria-hidden>
                {item.category === '团队活动' ? '🏀' : '📰'}
            </span>
        </div>
    );
};

const NewsList = () => {
    useDocTitle('江西族迹 | 新闻动态');
    const all = useMemo(() => getSortedNews(), []);
    const [filter, setFilter] = useState('全部');
    const list = filter === '全部' ? all : all.filter((n) => n.category === filter);

    return (
        <>
            <NavBar />
            <main className="bg-[#f4f7fb] min-h-screen text-gray-800">
                <header className="relative overflow-hidden pt-28 pb-14 md:pt-36 md:pb-16">
                    <div
                        className="absolute inset-0"
                        style={{
                            background:
                                'radial-gradient(ellipse 80% 60% at 20% 0%, #dbeafe 0%, transparent 55%), linear-gradient(180deg, #eff6ff 0%, #f4f7fb 100%)',
                        }}
                    />
                    <div className="relative max-w-3xl mx-auto px-6 text-center">
                        <p className="text-sm tracking-[0.28em] text-blue-700/80 font-semibold mb-5">江西族迹</p>
                        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">新闻动态</h1>
                        <p className="text-lg text-slate-600">产品进展、公司动态、团队活动与媒体报道</p>
                    </div>
                </header>

                <div className="max-w-6xl mx-auto px-6 pb-20 md:pb-28">
                    <div className="flex flex-wrap justify-center gap-2 mb-12">
                        {FILTERS.map((name) => (
                            <button
                                key={name}
                                type="button"
                                onClick={() => setFilter(name)}
                                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                                    filter === name
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-white text-slate-600 border border-slate-200 hover:border-blue-300'
                                }`}
                            >
                                {name}
                            </button>
                        ))}
                    </div>

                    {list.length === 0 ? (
                        <p className="text-center text-slate-500 py-16">该分类暂无内容</p>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {list.map((item) => {
                                const { full } = formatNewsDate(item.date);
                                return (
                                    <Link
                                        key={item.slug}
                                        to={`/news/${item.slug}`}
                                        className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden flex flex-col"
                                    >
                                        <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                                            <Cover item={item} />
                                        </div>
                                        <div className="p-6 flex flex-col flex-1">
                                            <div className="flex items-center gap-3 mb-3">
                                                <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${newsCategoryStyle[item.category] || 'bg-gray-100 text-gray-600'}`}>
                                                    {item.category}
                                                </span>
                                                <time className="text-xs text-gray-400">{full}</time>
                                            </div>
                                            <h2 className="text-lg font-bold text-slate-900 group-hover:text-blue-600 transition-colors leading-snug mb-2">
                                                {item.title}
                                            </h2>
                                            <p className="text-sm text-slate-500 leading-relaxed line-clamp-3">
                                                {item.summary}
                                            </p>
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </>
    );
};

export default NewsList;
